import React from 'react';
import PropTypes from 'prop-types';
import LazyLoadImg from '../../widgets/shared/LazyLoadImg';

import { sizedImageShape } from '../../../types';

const Card = ({
  altText,
  businessUnitTitle,
  contentType,
  link,
  rank,
  searchItemId,
  submit,
  title,
  thumbnailImage
}) => {
  const hasImage = thumbnailImage && thumbnailImage.url;

  return (
    <div className="card">
      <div className="content">
        <button
          type="button"
          className="btn-no-style"
          onClick={() =>
            submit({
              link,
              rank,
              searchItemId
            })
          }
          title={`Link to ${title}`}
        >
          <div className={`inner-image${thumbnailImage ? '' : ' no-thumbnail'} featured`}>
            {hasImage && (
              <LazyLoadImg src={thumbnailImage} alt={altText || `${title} Thumbnail Image`} />
            )}
          </div>
          <div className="inner-content">
            <p className="title">{title}</p>
            <span className="tag">{contentType}</span>
            {businessUnitTitle ? (
              <span className="tag">{businessUnitTitle}</span>
            ) : (
              <span className="tag">Trustmark</span>
            )}
          </div>
        </button>
      </div>
    </div>
  );
};

Card.defaultProps = {
  altText: '',
  businessUnitTitle: '',
  contentType: '',
  submit: item => {
    window.location.href = item.link;
  },
  thumbnailImage: ''
};

Card.propTypes = {
  altText: PropTypes.string,
  businessUnitTitle: PropTypes.string,
  contentType: PropTypes.string,
  link: PropTypes.string.isRequired,
  rank: PropTypes.number.isRequired,
  searchItemId: PropTypes.string.isRequired,
  submit: PropTypes.func,
  title: PropTypes.string.isRequired,
  thumbnailImage: sizedImageShape
};

export default Card;
